var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeavInfo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.25H24.25M6.75 1.75V4.25M19.25 1.75V4.25M12.997 13.8899C12.1222 12.916 10.6636 12.654 9.56767 13.5459C8.47172 14.4376 8.31742 15.9287 9.17809 16.9835C9.66399 17.579 10.8185 18.6229 11.7318 19.4191C12.1649 19.7967 12.3814 19.9856 12.6434 20.0629C12.8667 20.1287 13.1273 20.1287 13.3506 20.0629C13.6126 19.9856 13.8291 19.7967 14.2622 19.4191C15.1755 18.6229 16.33 17.579 16.8159 16.9835C17.6766 15.9287 17.5411 14.4282 16.4264 13.5459C15.3115 12.6634 13.8717 12.916 12.997 13.8899ZM5.75 24.25H20.25C21.6501 24.25 22.3503 24.25 22.885 23.9775C23.3554 23.7379 23.7379 23.3554 23.9775 22.885C24.25 22.3503 24.25 21.6501 24.25 20.25V8.25C24.25 6.84986 24.25 6.1498 23.9775 5.61503C23.7379 5.14461 23.3554 4.76216 22.885 4.52249C22.3503 4.25 21.6501 4.25 20.25 4.25H5.75C4.34987 4.25 3.6498 4.25 3.11503 4.52249C2.64461 4.76216 2.26216 5.14461 2.02249 5.61503C1.75 6.1498 1.75 6.84986 1.75 8.25V20.25C1.75 21.6501 1.75 22.3503 2.02249 22.885C2.26216 23.3554 2.64461 23.7379 3.11503 23.9775C3.6498 24.25 4.34986 24.25 5.75 24.25Z",
    stroke: "#D20A0A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeavInfo1);
export default __webpack_public_path__ + "static/media/leav-info-1.dad32a46ef30d5f6a36ce706a83f6a95.svg";
export { ForwardRef as ReactComponent };